<template>
    <STListItem class="right-stack smartphone-wrap-left" :selectable="true">
        <template #left>
            <EventImageBox :event="event" />
        </template>
        <p v-if="levelPrefix" class="style-title-prefix-list style-limit-lines">
            {{ levelPrefix }}
        </p>
        <h3 class="style-title-list larger">
            <span>{{ event.name }}</span>
        </h3>
        <p class="style-description-small">
            {{ Formatter.capitalizeFirstLetter(event.dateRange) }}
        </p>

        <p v-if="prefix" class="style-description-small">
            {{ $t('%b7') }} {{ prefix }}
        </p>

        <p v-if="event.meta.location?.name || event.meta.location?.address?.city" class="style-description-small">
            {{ event.meta.location?.name || event.meta.location?.address?.city }}
        </p>

        <p v-if="event.group" class="style-description-small">
            <span v-if="event.group.notYetOpen">{{ $t('%b8') }} {{ Formatter.date(event.group.activePreRegistrationDate ?? event.group.settings.registrationStartDate ?? new Date()) }}</span>
            <span v-else-if="event.group.closed">{{ $t('%b9') }}</span>
            <span v-else>{{ $t('%bA') }}</span>
        </p>

        <p v-if="event.group && app !== 'registration' && (event.group.organizationId === organization?.id || app === 'admin')" class="style-description-small">
            <span v-if="event.group.getMemberCount() !== null">{{ capitalizeFirstLetter(pluralText(event.group.getMemberCount() ?? 0, 'inschrijving', 'inschrijvingen')) }}</span>
        </p>

        <p v-if="event.webshopId && app !== 'registration'" class="style-description-small">
            {{ $t('%1As') }}
        </p>

        <template #right>
            <span v-if="!event.meta.visible" class="icon gray eye-off" :v-tooltip="$t('%UC')" />
            <span v-if="event.id" class="icon arrow-right-small gray" />
            <span v-else class="icon add gray" />
        </template>
    </STListItem>
</template>

<script setup lang="ts">
import type { Event } from '@stamhoofd/structures';
import { Formatter } from '@stamhoofd/utility';
import { computed } from 'vue';
import { useAppContext } from '../../context';
import { useOrganization, usePlatform } from '../../hooks';
import EventImageBox from './EventImageBox.vue';

const props = defineProps<{
    event: Event;
}>();

const platform = usePlatform();
const organization = useOrganization();
const app = useAppContext();

const levelPrefix = computed(() => {
    const prefixes: string[] = [];

    if (props.event.organizationId === null) {
        if (props.event.meta.organizationTagIds !== null) {
            const tagNames = platform.value?.config.tags.filter(t => props.event.meta.organizationTagIds?.includes(t.id)).map(t => t.name);
            prefixes.push(...tagNames);
        }
        else {
            prefixes.push($t(`%XF`));
        }
    }
    else {
        if (props.event.organizationId === organization.value?.id) {
            // skip
        }
        else {
            // Name of the organization
            if (props.event.meta.organizationCache?.name) {
                prefixes.push(props.event.meta.organizationCache?.name);
            }
        }
    }

    return Formatter.joinLast(prefixes, ', ', ' ' + $t(`%M1`) + ' ');
});

const prefix = computed(() => {
    const prefixes: string[] = [];

    if (props.event.meta.defaultAgeGroupIds !== null) {
        for (const ageGroupId of props.event.meta.defaultAgeGroupIds) {
            const ageGroup = platform.value?.config.defaultAgeGroups.find(g => g.id === ageGroupId);
            if (ageGroup) {
                prefixes.push(ageGroup.name);
            }
        }
    }

    if (props.event.meta.groups !== null) {
        for (const group of props.event.meta.groups) {
            prefixes.push(group.name);
        }
    }
    return Formatter.joinLast(prefixes, ', ', ' ' + $t(`%M1`) + ' ');
});

</script>
